import { Deserializable } from '../_common/deserializable';

export class MultiSub implements Deserializable {
  phone: string;
  count: number;
  firstSubAt: number;
  lastSubAt: number;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
